// extracted by mini-css-extract-plugin
export default {"signedBlock":"OverallInfo_signedBlock__hDZIY","eSignatureBlock":"OverallInfo_eSignatureBlock__ifiq1"};